import { NgClass, NgStyle } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-stars',
  imports: [
    MatIcon,
    NgClass,
    NgStyle,
  ],
  templateUrl: './stars.html',
  styleUrl: './stars.scss'
})
export class StarsComponent implements OnInit {
  control = input<FormControl>();

  readOnly = input<boolean>(true);

  stars = input<number>(0);

  ngOnInit() {
    if (this.readOnly() && this.control()) {
      throw new Error('Cannot set readOnly and control at the same time for StarsComponent');
    }
  }
}
